import { Button, Sidebar } from 'components/common';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { updateTextTemplateService } from 'features/documents/services/document';
import { ErrorMessage, Form, Formik } from 'formik';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import InfoDemandeDocument from './InfoDemandeDocument';
const MinthrQuill = dynamic(() => import('components/common/MinthrQuill'), {
  ssr: false,
});

interface EditTemplateProps {
  id: number;
  text: string;
  refetch: () => void;
}
const EditTemplate: React.FC<SideBarProps<EditTemplateProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { t } = useTranslation();
  const { closeSidebar, openSidebar } = useSidebarManager();
  const [templateContent, setTemplateContent] = useState(params.text);

  const validationSchema = Yup.object().shape({
    text: Yup.string().trim().required(t('RequiredAttribute')),
  });

  const handelSaveTamplate = async (values: {
    id: number;
    text: string;
  }): Promise<void> => {
    const response = await updateTextTemplateService(values);
    if (response.success) {
      toast.success(t('Default.succesMessage'));
      closeSidebar(EditTemplate);
      openSidebar(InfoDemandeDocument, true, {
        id: params.id,
        refetch: params.refetch,
      });
    } else {
      toast.error(response.message);
    }
  };

  return (
    <Sidebar
      size="xl"
      type="primary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-2 minthr-border-b">
        <div className="minthr-icon-bg minthr-icon-bg-l minthr-icon-bg-secondary minthr-icon-circle minthr-mr-3">
          <img className="minthr-icon-m" src="/icons/puzzle.svg" alt="" />
        </div>
        <h3>{t('doc.edit')}</h3>
        <button
          className="minthr-sidebar-close"
          type="button"
          onClick={() => {
            closeSidebar(EditTemplate);
          }}
        >
          <img src="/icons/close.svg" alt="" />
        </button>
      </div>
      <Formik
        initialValues={{ id: params.id, text: params.text }}
        onSubmit={handelSaveTamplate}
        validationSchema={validationSchema}
      >
        {({ setFieldValue }) => (
          <Form>
            <div className="minthr-mt-2">
              <div className=" minthr-w-100   ">
                <MinthrQuill
                  className="w-100 h-100 "
                  content={templateContent}
                  setContent={setTemplateContent}
                  onChange={(content: string) => {
                    setFieldValue('text', content);
                  }}
                />
                <ErrorMessage name="text" />
              </div>
            </div>
            <div className="minthr-sidebar-footer minthr-box-shadow minthr-flex minthr-flex-items-center minthr-flex-space-between minthr-py-4 minthr-mx-n5 minthr-px-4 minthr-mt-auto">
              <Button
                type="submit"
                className="minthr-btn minthr-btn-primary minthr-ml-auto"
              >
                {t('btn.save')}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Sidebar>
  );
};

export default EditTemplate;
